<div *transloco="let t">
  @let current = show();

  @if (current) {
    <multisite-show-banner [show]="current"></multisite-show-banner>
  }

  <div class="container">
    @if (current) {
      <div class="row">
        <div class="col-lg-8">
          @if (translation.translating()) {
            <div class="d-flex align-items-center my-2" role="status">
              <multisite-loader-globe-animation-detail [width]="40" [height]="40"></multisite-loader-globe-animation-detail>
              <span class="ml-2">{{ t('news.translating') }}</span>
            </div>
          }

          @if (current.description) {
            <div class="mb-4 text-break" [innerHTML]="current.description | insightMarkdown"></div>
          }

          <h2 class="h4 font-weight-bold mt-4">{{ t('shows.episodes') }}</h2>

          @if (current.seasons.length) {
            <div class="btn-group flex-wrap mb-3" role="group">
              <button type="button" class="btn btn-sm" [class.btn-primary]="season() === null" [class.btn-outline-primary]="season() !== null" (click)="chooseSeason(null)">
                {{ t('shows.all_seasons') }}
              </button>
              @for (s of current.seasons; track s.id) {
                <button type="button" class="btn btn-sm" [class.btn-primary]="season() === s.number" [class.btn-outline-primary]="season() !== s.number" (click)="chooseSeason(s.number)">
                  {{ s.title || t('shows.season_number', { number: s.number }) }}
                </button>
              }
            </div>
          }

          <div class="list-group list-group-flush mb-3">
            @for (episode of episodes(); track episode.id) {
              <a class="list-group-item list-group-item-action px-0 d-flex" [routerLink]="[definition.showsPath, current.slug, episode.slug]">
                @if (episodeImage(episode); as image) {
                  <img class="episode-image mr-3 rounded" [src]="image | imageUrl: 'w_400,c_fill,ar_16:9'" [alt]="image.alt_text ?? ''" loading="lazy" />
                }
                <div class="flex-grow-1 episode-text">
                  <small class="text-muted d-block">
                    @if (episodeLabel(episode); as label) {
                      <span>{{ label }}</span>
                      <span class="mx-1">·</span>
                    }
                    <span>{{ episode.publishedAt | date: 'mediumDate' }}</span>
                  </small>
                  <span class="d-block font-weight-bold">{{ episode.title }}</span>
                  @if (episode.summary) {
                    <div class="small text-muted text-break" [innerHTML]="episode.summary | insightMarkdown"></div>
                  }
                </div>
              </a>
            } @empty {
              @if (!loadingEpisodes()) {
                <p class="text-muted">{{ t('common.no_results') }}</p>
              }
            }
          </div>

          @if (hasMoreEpisodes()) {
            <button type="button" class="btn btn-outline-primary btn-sm mb-4" [disabled]="loadingEpisodes()" (click)="moreEpisodes()">{{ t('common.show_more') }}</button>
          }

          @if (clips().length) {
            <h2 class="h4 font-weight-bold mt-4">{{ t('shows.clips') }}</h2>
            <div class="list-group list-group-flush mb-4">
              @for (clip of clips(); track clip.id) {
                <a class="list-group-item list-group-item-action px-0" [routerLink]="clipPath(definition, clip)">
                  <small class="text-muted d-block">{{ t('shows.clip_kind.' + clip.kind) }}</small>
                  <span class="d-block">{{ clip.title }}</span>
                </a>
              }
            </div>
          }
        </div>

        <div class="col-lg-4">
          <div class="sticky-top pt-3">
            <div class="mb-3">
              <multisite-shows-like-button [item]="ref()"></multisite-shows-like-button>
            </div>

            <div class="mb-3">
              <multisite-shows-subscribe-button [show]="current.slug"></multisite-shows-subscribe-button>
            </div>

            @if (current.channelLinks.length) {
              <p class="h5">{{ t('shows.platforms') }}</p>
              <div class="d-flex flex-wrap mb-4">
                @for (link of current.channelLinks; track link.url) {
                  <a class="btn btn-outline-secondary btn-sm mr-2 mb-2" [href]="link.url" target="_blank" rel="noopener">{{ channelNames[link.channel] }}</a>
                }
              </div>
            }

            <div class="mb-4">
              <multisite-shows-credits [crew]="current.crew"></multisite-shows-credits>
            </div>

            @if (hasTools()) {
              <a class="btn btn-link px-0" [routerLink]="[definition.toolsPath]">{{ t('tools.all_tools') }} <i class="fa-solid fa-angle-right ml-1"></i></a>
            }
          </div>
        </div>
      </div>
    }

    @if (!current && loading()) {
      <div class="my-5"><multisite-loader-globe-animation-detail [width]="100" [height]="100"></multisite-loader-globe-animation-detail></div>
    }

    @if (notFound()) {
      <div class="text-center my-5">
        <p>{{ t('common.not_found') }}</p>
        <a [routerLink]="[definition.showsPath]">{{ t('shows.all_shows') }}</a>
      </div>
    }

    @if (failed()) {
      <p class="text-danger my-5 text-center">{{ t('error.could_not_load') }}</p>
    }
  </div>
</div>
